import styled from 'styled-components';

import Card from 'components/common/Card';
import Text from 'components/common/Text';
import Heading from 'components/common/Typography/Heading';

interface IProps {
  isNearby?: boolean;
  mb?: number;
  mt?: number;
  ml?: number;
  mr?: number;
  isMobileHidden?: boolean;
  isClickable?: boolean;
}

export const ProfileDetailsCardWrapper = styled(Card)`
  margin: 0 0 16px;
  max-width: 550px;
  width: 100%;
  box-shadow: 0px 4px 10px rgb(0 0 0 / 2%);
  margin-bottom: 27px;
`;
export const CoverImage = styled.div`
  position: relative;
  width: 100%;
  height: 366px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  overflow: hidden;

  & img {
    object-fit: cover;
  }

  @media (max-width: 800px) {
    height: 228px;
  }
`;

export const ShadowGradient = styled.div`
  width: 100%;
  height: 120px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 9.67%,
    rgba(28, 31, 41, 0.7) 100%
  );
  display: none;
  flex-direction: column;
  justify-content: flex-end;
  box-sizing: border-box;
  padding: 0 32px 16px 32px;

  @media (max-width: 800px) {
    display: flex;
  }
`;

export const UserInfo = styled.div`
  display: flex;
  position: relative;
  padding: 8px 16px 6px 16px;
`;

export const PhotoWithNearbyWrap = styled.div`
  position: absolute;
  top: -8px;
`;

export const UserProfilePhotoWrap = styled.div`
  width: 84px;
  height: 84px;
  border-radius: 50%;
  box-sizing: border-box;
  border: 3px solid ${(props) => props.theme.colors.white};
  filter: drop-shadow(0px 4px 20px rgba(0, 0, 0, 0.06));
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

export const NearbyBlock = styled.div`
  font-family: ${(props) => props.theme.typography.fontFamily.primary};
  font-weight: ${(props) => props.theme.typography.fontWeight.regular};
  font-size: ${(props) => props.theme.typography.fontSize.f2};
  line-height: 130%;
  /* identical to box height, or 16px */
  div {
    padding-left: 4px;
  }
  display: flex;
  justify-content: center;
  cursor: pointer;
  align-items: center;
  letter-spacing: 0.02em;

  /* Interaction-01 */

  color: ${(props) => props.theme.colors.orange};
`;

export const UserDetailsWrap = styled.div<IProps>`
  display: flex;
  flex-direction: column;
  margin-left: 96px;
  min-height: ${({ isNearby }) => (isNearby ? '80px' : '64px')};
`;

export const UsernameText = styled(Heading)`
  font-size: ${(props) => props.theme.typography.fontSize.f7};
  line-height: 130%;
  letter-spacing: 0.02em;
  font-weight: ${(props) => props.theme.typography.fontWeight.semiBold};
  color: ${(props) => props.theme.colors.black};
  margin-right: 5px;
`;

export const IconWrapper = styled.div`
  width: 16px;
  height: 16px;
  margin-right: 7px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 800px) {
    display: none;
  }
`;

export const CentralizeContent = styled.div<IProps>`
  display: flex;
  align-items: center;
  margin-bottom: ${({ mb }) => (mb ? `${mb}px` : '0')};
  margin-top: ${({ mt }) => (mt ? `${mt}px` : '0')};
  margin-left: ${({ ml }) => (ml ? `${ml}px` : '0')};
  margin-right: ${({ mr }) => (mr ? `${mr}px` : '0')};

  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : 'auto')};

  @media (max-width: 800px) {
    display: ${({ isMobileHidden }) => (isMobileHidden ? 'none' : 'flex')};
  }
`;

export const TextWrap = styled(Text)`
  font-size: ${(props) => props.theme.typography.fontSize.f5};
  font-weight: ${(props) => props.theme.typography.fontWeight.regular};
  line-height: 130%;
  letter-spacing: 0.02em;
  color: ${(props) => props.theme.colors.neutral.n10};
`;

export const FollowingInfoWrap = styled.div`
  display: flex;
  margin-top: 2px;
  flex-wrap: wrap;
`;

export const CountText = styled(Text)`
  color: ${(props) => props.theme.colors.black};
  margin-right: 4px;
  font-size: ${(props) => props.theme.typography.fontSize.f5};
  line-height: 130%;
  letter-spacing: 0.02em;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 2px;
  padding: 0 16px 16px 16px;
`;

export const MessageButtonWrap = styled.div`
  margin-left: 10px;
  div {
    text-align: center;
    display: flex;
    flex-direction: column;
  }

  & > button {
    height: 43px;
    &:hover {
      background: ${(props) => props.theme.colors.neutral.n3};
    }
  }
`;
export const OptionsButton = styled.div`
  margin-left: 10px;
  & button {
    height: 43px;
    width: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${(props) => props.theme.colors.neutral.n3};
    border-radius: 8px;
    &:hover {
      background: ${(props) => props.theme.colors.neutral.n3};
    }
    & svg {
      transform: rotate(90deg);
      & path {
        fill: ${(props) => props.theme.colors.black};
      }
    }
  }
`;
export const DotButton = styled.span``;
